// Loads one game day of restroom data (v2 route): the same request and shape the facilities game-day view uses.
import moment from 'moment';
import { getFacilitiesAPI } from './dummyLiveData.js';
import { transformRestrooms } from './facilitiesMetrics';

export const fetchFacilitiesDay = (currentLocation, authCtx, date) =>
  new Promise((resolve, reject) => {
    // Same as util's getQueuesAPI unless dummy data mode is on (local dev only)
    getFacilitiesAPI(currentLocation)(
      'get-facilities-restrooms-location-daily-data-v2',
      {
        timezone: currentLocation.timeZone,
        restrooms: currentLocation.restrooms,
        venue: authCtx.venue,
        locationId: currentLocation.id,
        measurement: currentLocation.measurement,
        queueMeasurement: currentLocation.queueMeasurement || '',
        date: moment(date).format('YYYY-MM-DD'),
      },
      (data, error) => {
        if (error) {
          reject(error);
          return;
        }
        resolve(transformRestrooms(data, currentLocation.restrooms || []));
      },
      authCtx.token
    );
  });
